export const step4 = {
  changeCompanyArea(area: string) {
    this.userInput.companyArea = area;
    this.moveNext();
  },

  get isNextBtnActive() {
    return true;
  },
};
